import styled from 'styled-components';
import { CentralModal, colours, Paragraph } from '@cambridgeassessment/cambridge-ui';

export const StyledContainer = styled.div`
  max-width: 1100px;
  width: 100;
  font-family: SourceSansPro;
`;

export const StyledWrapper = styled.div`
  max-width: 880px;
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const StyledHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  button.MuiButton-root {
    margin-top: 24px;
    float: right;
  }
`;

export const StyledGridItem = styled.div``;

export const ConsortiaActionsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  & > button {
    margin-right: 6px;
  }
`;

export const ButtonText = styled.div`
  text-decoration: underline;
  color: ${colours.scienceBlue};
`;

export const StyledParagraph = styled(Paragraph)`
  max-width: 880px;
  margin: 0px;
`;

export const StyledDeleteModal = styled(CentralModal)`
  .MuiDialog-paper {
    width: 440px;
  }
  .MuiDialogTitle-root > h2 {
    font-size: 18px;
  }
  .MuiDialogContentText-root {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
  .MuiDialogActions-root {
    button:nth-child(2) {
      background-color: ${colours.cherry};
      border: 2px solid ${colours.cherry};
    }
  }
`;

export const StyledWarningModal = styled(CentralModal)`
  .MuiDialog-paper {
    width: 440px;
  }
  .MuiDialogTitle-root > h2 {
    font-size: 18px;
    height: unset;
  }
  .MuiDialogContentText-root {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }
  .MuiDialogActions-root {
    button:nth-child(2) {
      background-color: ${colours.cherry};
      border: 2px solid ${colours.cherry};
    }
  }
`;

export const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const TextColumn = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: SourceSansPro;
`;

export const StyledSearchFieldContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`;

export const StyledConsortiumItemContainer = styled.div<{ minHeight: number }>`
  margin-bottom: 60px;

  & > div.MuiExpansionPanel-root {
    margin: 16px 0;
  }

  .MuiAccordion-root {
    margin-top: 8px;
    &:hover {
      cursor: pointer;
      background-color: ${colours.alabaster};
    }
  }

  &.expanded {
    min-height: ${(props): number => props.minHeight}px;
  }
`;
